import { render } from "./vue-thailand-address-autocomplete.vue?vue&type=template&id=c1d446da&scoped=true&ts=true"
import script from "./vue-thailand-address-autocomplete.vue?vue&type=script&lang=ts"
export * from "./vue-thailand-address-autocomplete.vue?vue&type=script&lang=ts"

import "./vue-thailand-address-autocomplete.vue?vue&type=style&index=0&id=c1d446da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d446da"]])

export default __exports__